import dayjs, { Dayjs } from 'dayjs';

/**
 * Makes dates read from an editable URL safe to query with: the date pickers never allow a date in the
 * future, so those are dropped, and a reversed range is swapped. A start date alone (ending now) and an end date
 * alone (starting before it) are then always valid ranges.
 */
export const normalizeEventDateRange = (dateStart: Dayjs | null, dateEnd: Dayjs | null, now: Dayjs = dayjs()) => {
  const start = dateStart && !dateStart.isAfter(now) ? dateStart : null;
  const end = dateEnd && !dateEnd.isAfter(now) ? dateEnd : null;

  return start && end && start.isAfter(end) ? { dateStart: end, dateEnd: start } : { dateStart: start, dateEnd: end };
};
